import { useContext } from 'react';
import AuthContext from './context';
import { User } from '../../utils/interface/user';

const useAuth = () => useContext<{ user: User }>(AuthContext);

export default useAuth;
